"use strict"

angular.module("core")
.service("PreAuthorizedPaymentAgreementButtonService", function(appConfig, $http) {
    this.emailAgreement = function(partnershipId, email) {
        return $http.post(
            appConfig.API_SERVER + "/payment-methods/" + appConfig.APP + "/partnership-pre-authorized-payment-agreement/" + partnershipId + "/send/",
            {email: email}
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/pre-authorized-payment-agreement-button/pre-authorized-payment-agreement-button.service.js
// module id = 657
// module chunks = 0